"use client";

import { useEffect, useState } from "react";

type Props = {
  className?: string;
};

export function ThemeToggle({ className = "" }: Props) {
  const [mounted, setMounted] = useState(false);
  const [theme, setTheme] = useState<"light" | "dark">("light");

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setMounted(true);
    const isDark = document.documentElement.classList.contains("dark");
    setTheme(isDark ? "dark" : "light");
  }, []);

  function toggleTheme() {
    const next = theme === "dark" ? "light" : "dark";
    document.documentElement.classList.toggle("dark", next === "dark");
    localStorage.setItem("theme", next);
    setTheme(next);
  }

  if (!mounted) return null;

  return (
    <button
      aria-label="Toggle theme"
      onClick={toggleTheme}
      className={`
        inline-flex items-center justify-center
        w-9 h-9 rounded-full
        text-neutral-500
        hover:bg-neutral-100
        dark:text-neutral-400 dark:hover:bg-neutral-800
        transition-colors
        ${className}
      `}
    >
      <span
        className="material-symbols-outlined text-[20px] leading-none"
        aria-hidden
      >
        {theme === "dark" ? "light_mode" : "dark_mode"}
      </span>
    </button>
  );
}
